<template>
  <a-table :columns="columns" :data-source="data" bordered>
    <a slot="qr_img" slot-scope="text">
      <a-tooltip placement="left">
        <template slot="title">
          <img :src="text" alt="" style="width:120px;height:120px" />
        </template>
        <img :src="text" alt="" style="width:40px;height:40px" />
      </a-tooltip>
    </a>
    <template slot="action" slot-scope="text, record">
      <a-popconfirm
        title="确定退票么？"
        ok-text="确定"
        cancel-text="取消"
        @confirm="confirm(record.code)"
      >
        <a-button type="dashed">退票</a-button>
      </a-popconfirm>
    </template>
  </a-table>
</template>
<script>
import { getOrders, createRefund } from "@/api/api-user";

const columns = [
  {
    title: "订单号",
    dataIndex: "ordersn",
    ellipsis: true
  },
  {
    title: "票名",
    dataIndex: "ticket_name"
  },
  {
    title: "种类",
    dataIndex: "shape"
  },
  {
    title: "姓名",
    dataIndex: "name"
  },
  {
    title: "二维码",
    dataIndex: "qr_img",
    scopedSlots: { customRender: "qr_img" },
    ellipsis: true
  },
  {
    title: "使用日期",
    dataIndex: "use_date"
  },
  {
    title: "场次",
    dataIndex: "ticket_type"
  },
  {
    title: "出票时间",
    dataIndex: "createtime"
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  data() {
    return {
      columns,
      data: []
    };
  },
  methods: {
    getList() {
      getOrders({ page: 1, status: 0 }).then(res => {
        this.data = res.list;
      });
    },
    confirm(code) {
      createRefund({ code: code }).then(res => {
        if (res) {
          this.$message.success("申请提交成功，请等待审核");
          this.getList();
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
